import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EntityCertificationsTab } from '@/app/(client)/my-styles/-components/EntityCertificationsTab';
import { entityCertificationsQueryOptions } from '@/app/(client)/my-styles/-hooks/useEntityCertificationsQuery';
import type { EntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

const COMPONENT_KIND_MAP: Record<string, EntityKindPath> = {
  components: 'styles',
  'component-variants': 'variants',
  'component-skus': 'skus',
};

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/certifications',
)({
  validateSearch: z.object({
    dialog: z.enum(['create-certification-manual']).optional().catch(undefined),
  }),
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      entityCertificationsQueryOptions(params.id, { page: 1, count: 50 }),
    ),
  component: CertificationsRoute,
});

function CertificationsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = COMPONENT_KIND_MAP[kind] ?? 'styles';
  return <EntityCertificationsTab kind={safeKind} entityId={id} />;
}
